import { ObservableArray, View, ViewModel } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { ComboViewModel } from "./combo-viewModel"

export class ComboView extends FormBuilderComponentView<ComboViewModel>{
    GetViewUniqueId(): string {
        return "V-EFA69066-AFFC-463B-9747-56175D54C23A"
    }
    loadHtml(): string {
        let element = require('./combo.html').default;
        let style = require('./combo.less');
        return element;
    }
    constructor() {
       super();
    }

    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set SelectedItem(v: ViewModel) { this._SelectedItem = v; } public get SelectedItem(): ViewModel { return this._SelectedItem;} private _SelectedItem: ViewModel;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;


}
